import { type PropsWithChildren } from 'react'
import { useIsMobileVariant } from '../../theme'
import { Box } from '../../primitives/Box'

export type AccordionContentProps = PropsWithChildren<{
  isFullscreen?: boolean
  noPaddingSides?: boolean
  noPaddingTop?: boolean
  noPaddingBottom?: boolean
}>

const getStyles = (
  { isFullscreen, noPaddingSides, noPaddingTop, noPaddingBottom }: AccordionContentProps,
  isMobileVariant: boolean
) => {
  if (isFullscreen || (noPaddingSides && noPaddingTop && noPaddingBottom)) {
    return {
      flex: '1',
      minHeight: 0,
    }
  }

  const px = isMobileVariant ? 2 : 3
  const pt = noPaddingTop ? 0 : 2
  const pb = noPaddingBottom ? 0 : 2

  return { flex: '1', minHeight: 0, px: noPaddingSides ? 0 : px, pt, pb }
}

export const AccordionContent = ({ children, ...rest }: AccordionContentProps) => {
  const isMobileVariant = useIsMobileVariant()

  const sx = getStyles(rest, isMobileVariant)

  return <Box sx={sx}>{children}</Box>
}
